/**
 * Конфігурація навчальних майданчиків
 *
 * Навчальні майданчики - це спеціальні зони з унікальним дизайном:
 * - Зелена область з іконкою лижника
 * - Label: зелене коло, білий фон, зелений текст
 *
 * Навчальні траси (Track7DBlue/Track7DGreen, Track17ABlue/Track17AGreen) - це звичайні траси зеленого кольору
 * з стандартним дизайном label як у інших трас.
 */

// Список ключів які є навчальними майданчиками
export const LEARNING_AREA_KEYS = [
	'Track7EGreen',
	'Track2DGreen',
	'Track1DGreen'
	// Додавайте інші майданчики тут
];

/**
 * Перевірити чи є трек навчальним майданчиком
 * @param {string} trackKey - ключ треку (наприклад 'Track7EGreen')
 * @returns {boolean}
 */
export const isLearningArea = (trackKey) => {
	return LEARNING_AREA_KEYS.includes(trackKey);
};

/**
 * Отримати кольори для label навчального майданчика в залежності від стану
 * @param {string} state - режим відображення ('status' або 'difficulty')
 * @param {string} workState - статус роботи ('open', 'closed', 'waiting')
 * @returns {Object} об'єкт з кольорами { colors: [outer, inner], textColor }
 */
export const getLearningAreaLabelColors = (state, workState) => {
	const isOpen = workState === 'open';

	// В режимі difficulty завжди зелений
	if (state !== 'status') {
		return {
			colors: ['#4CAF50', 'white'],
			textColor: '#4CAF50'
		};
	}

	// В режимі status - зелений якщо open, помаранчевий якщо closed/waiting
	return {
		colors: isOpen ? ['#4CAF50', 'white'] : ['#FF8C00', 'white'],
		textColor: isOpen ? '#4CAF50' : '#FF8C00'
	};
};

/**
 * Отримати кольори для навчального майданчика в залежності від стану
 * @param {string} state - режим відображення ('status' або 'difficulty')
 * @param {string} workState - статус роботи ('open', 'closed', 'waiting')
 * @returns {Object} об'єкт з кольорами для всіх елементів
 */
export const getLearningAreaColors = (state, workState) => {
	const isOpen = workState === 'open';

	// В режимі difficulty завжди зелений
	if (state !== 'status') {
		return {
			areaFill: '#D0F2D9',
			areaBorder: '#97DFAB',
			skierBg: '#15BC40',
			connector: 'rgba(21, 188, 64, 1)'
		};
	}

	// В режимі status - зелений якщо open, помаранчевий якщо closed/waiting
	return {
		areaFill: isOpen ? '#D0F2D9' : 'rgba(252, 234, 198, 1)',
		areaBorder: isOpen ? '#97DFAB' : 'rgba(255, 209, 116, 1)',
		skierBg: isOpen ? '#15BC40' : 'rgba(255, 165, 0, 1)',
		connector: isOpen ? '#97DFAB' : 'rgba(255, 209, 116, 1)'
	};
};
